import React, { useState } from 'react';
import { Play, Lock, Award, BookOpen, CheckCircle, Plus, Video, ExternalLink, Bot, Zap, ArrowRight } from 'lucide-react';

export default function Academy({ userRole = 'client', currentPlan = 'free', embedded = false }) {
  const [activeCategory, setActiveCategory] = useState('todos');
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [newCourse, setNewCourse] = useState({
    title: '',
    category: 'onboarding',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    duration: '10 min',
    requiredPlan: 'free',
    description: ''
  });

  const [courses, setCourses] = useState([
    {
      id: 1,
      title: 'Cómo conectar tu WhatsApp y activar tu Asistente IA',
      category: 'onboarding',
      duration: '6 min',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      requiredPlan: 'free',
      isFree: true,
      description: 'Aprende a vincular tu número de WhatsApp con Keyla IA en menos de 2 minutos utilizando Evolution API.'
    },
    {
      id: 2,
      title: 'Configuración de Agenda, Horarios y Equipo de Trabajo',
      category: 'onboarding',
      duration: '12 min',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      requiredPlan: 'free',
      isFree: true,
      description: 'Parametriza tus servicios, añade profesionales con foto y sincroniza sus calendarios sin errores.'
    },
    {
      id: 3,
      title: 'Estrategias de Cierre y Ventas Automáticas con IA en WhatsApp',
      category: 'ventas',
      duration: '25 min',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      requiredPlan: 'pro',
      isFree: false,
      description: 'Masterclass exclusiva: Cómo estructurar tus Reglas de Oro para triplicar la tasa de conversión en tu negocio.'
    },
    {
      id: 4,
      title: 'Automatización de Caja, Finanzas y Cálculo de Comisiones',
      category: 'gestion',
      duration: '18 min',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      requiredPlan: 'pro',
      isFree: false,
      description: 'Gestiona ingresos por Nequi/Daviplata, genera cierres de caja instantáneos y liquida nómina sin esfuerzo.'
    },
    {
      id: 5,
      title: 'Masterclass VIP: Menú Digital, Domicilios y KDS para Cocina',
      category: 'vip',
      duration: '30 min',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      requiredPlan: 'vip',
      isFree: false,
      description: 'Implementación corporativa del Monitor de Cocina KDS y flujos automáticos de despacho de domicilios.'
    }
  ]);

  const categories = [
    { id: 'todos', name: 'Todos los Módulos' },
    { id: 'onboarding', name: 'Onboarding & Inicio' },
    { id: 'ventas', name: 'Ventas & IA' },
    { id: 'gestion', name: 'Gestión & Finanzas' },
    { id: 'vip', name: 'Exclusivo VIP' }
  ];

  const canAccess = (course) => {
    if (course.isFree || course.requiredPlan === 'free') return true;
    if (userRole === 'master') return true;
    if (currentPlan === 'vip') return true;
    if (currentPlan === 'pro' && course.requiredPlan === 'pro') return true;
    return false;
  };

  const filteredCourses = activeCategory === 'todos'
    ? courses
    : courses.filter(c => c.category === activeCategory);

  const handleCreateCourse = (e) => {
    e.preventDefault();
    const created = {
      id: Date.now(),
      title: newCourse.title,
      category: newCourse.category,
      duration: newCourse.duration || '15 min',
      videoUrl: newCourse.videoUrl,
      requiredPlan: newCourse.requiredPlan,
      isFree: newCourse.requiredPlan === 'free',
      description: newCourse.description
    };
    setCourses([created, ...courses]);
    setShowAdminModal(false);
    setNewCourse({
      title: '',
      category: 'onboarding',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      duration: '10 min',
      requiredPlan: 'free',
      description: ''
    });
  };

  return (
    <div className={`min-h-screen bg-seryi-bg-dark text-seryi-text font-sans ${embedded ? 'p-0' : 'pb-16'}`}>
      {/* NAVBAR Si es standalone */}
      {!embedded && (
        <nav className="border-b border-white/10 bg-seryi-bg-dark/80 backdrop-blur-md sticky top-0 z-50 mb-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-seryi-green to-[#00cc7d] flex items-center justify-center shadow-lg shadow-seryi-green/20">
                <Bot className="text-seryi-bg-dark" size={24} />
              </div>
              <span className="text-xl font-black text-white tracking-tight">KEYLA<span className="text-seryi-green">Academy</span></span>
            </a>
            <div className="flex items-center gap-4">
              <a href="/planes" className="text-sm font-semibold text-white hover:text-seryi-green transition-colors">
                Ver Planes
              </a>
              <a href="/dashboard" className="px-5 py-2.5 rounded-xl bg-seryi-green text-seryi-bg-dark font-extrabold text-sm hover:brightness-110 transition-all shadow-lg">
                Mi Consola
              </a>
            </div>
          </div>
        </nav>
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* HEADER ACADEMY */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-8">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-seryi-green/10 border border-seryi-green/20 text-seryi-green text-xs font-extrabold uppercase mb-2">
              <BookOpen size={14} /> Centro de Formación y LMS
            </div>
            <h1 className="text-3xl font-black text-white">
              Keyla<span className="text-seryi-green">Academy</span>
            </h1>
            <p className="text-sm text-seryi-text mt-1">
              Aprende a dominar tu CRM, configurar tu IA y duplicar tus ventas en tiempo récord.
            </p>
          </div>

          {userRole === 'master' && (
            <button
              onClick={() => setShowAdminModal(true)}
              className="px-5 py-2.5 rounded-xl bg-seryi-green text-seryi-bg-dark font-extrabold text-sm hover:brightness-110 transition-all flex items-center gap-2 shadow-lg"
            >
              <Plus size={16} /> Subir / Editar Tutorial (Admin)
            </button>
          )}
        </div>

        {/* CATEGORY FILTER */}
        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`px-4 py-2 rounded-xl text-xs font-bold transition-all ${
                activeCategory === cat.id
                  ? 'bg-seryi-green text-seryi-bg-dark shadow-lg'
                  : 'bg-white/5 text-seryi-text hover:text-white hover:bg-white/10'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        {/* COURSES GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCourses.map((course) => {
            const hasAccess = canAccess(course);
            return (
              <div
                key={course.id}
                onClick={() => hasAccess ? setSelectedCourse(course) : null}
                className={`bg-white/5 border rounded-3xl overflow-hidden transition-all flex flex-col justify-between ${
                  hasAccess
                    ? 'border-white/10 hover:border-seryi-green/50 cursor-pointer hover:translate-y-[-2px]'
                    : 'border-white/5 opacity-80'
                }`}
              >
                {/* THUMBNAIL */}
                <div className="relative aspect-video bg-seryi-bg-dark/80 flex items-center justify-center border-b border-white/10 group">
                  {hasAccess ? (
                    <div className="w-14 h-14 rounded-full bg-seryi-green text-seryi-bg-dark flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                      <Play size={24} className="fill-seryi-bg-dark ml-1" />
                    </div>
                  ) : (
                    <div className="w-14 h-14 rounded-full bg-white/10 text-white flex items-center justify-center">
                      <Lock size={24} />
                    </div>
                  )}

                  <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-seryi-bg-dark/90 text-white text-[10px] font-extrabold">
                    {course.duration}
                  </span>

                  {!course.isFree && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-gradient-to-r from-seryi-green to-[#00cc7d] text-seryi-bg-dark text-[10px] font-black uppercase">
                      Plan {course.requiredPlan.toUpperCase()}
                    </span>
                  )}
                </div>

                {/* CONTENT */}
                <div className="p-6 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-base font-bold text-white mb-2 line-clamp-2">
                      {course.title}
                    </h3>
                    <p className="text-xs text-seryi-text line-clamp-2 mb-4">
                      {course.description}
                    </p>
                  </div>

                  {hasAccess ? (
                    <div className="flex items-center gap-1 text-xs font-bold text-seryi-green mt-2">
                      <span>Ver Clase</span>
                      <ArrowRight size={14} />
                    </div>
                  ) : (
                    <a
                      href="/planes"
                      onClick={(e) => e.stopPropagation()}
                      className="w-full py-2.5 rounded-xl bg-seryi-green/20 text-seryi-green text-xs font-extrabold text-center hover:bg-seryi-green hover:text-seryi-bg-dark transition-colors block"
                    >
                      Mejorar mi Plan para Ver
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* MODAL REPRODUCTOR DE VIDEO */}
      {selectedCourse && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
          <div className="bg-seryi-bg-dark border border-white/20 rounded-3xl max-w-4xl w-full overflow-hidden shadow-2xl">
            <div className="p-6 border-b border-white/10 flex items-center justify-between">
              <div>
                <h3 className="text-lg font-bold text-white">{selectedCourse.title}</h3>
                <p className="text-xs text-seryi-text">{selectedCourse.description}</p>
              </div>
              <button
                onClick={() => setSelectedCourse(null)}
                className="px-4 py-2 rounded-xl bg-white/10 text-white text-xs font-bold hover:bg-white/20"
              >
                Cerrar
              </button>
            </div>
            <div className="aspect-video w-full bg-black">
              <iframe
                src={selectedCourse.videoUrl}
                title={selectedCourse.title}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}

      {/* MODAL ADMIN PARA SUBIR O EDITAR CURSO */}
      {showAdminModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
          <div className="bg-seryi-bg-dark border border-white/20 rounded-3xl max-w-lg w-full p-6 shadow-2xl">
            <h3 className="text-xl font-bold text-white mb-4">Subir Nuevo Tutorial KeylaAcademy</h3>
            <form onSubmit={handleCreateCourse} className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-seryi-text mb-1">Título del Curso / Tutorial</label>
                <input
                  type="text"
                  required
                  value={newCourse.title}
                  onChange={(e) => setNewCourse({ ...newCourse, title: e.target.value })}
                  placeholder="Ej: Cómo agendar en Google Calendar"
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white"
                />
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold text-seryi-text mb-1">Categoría</label>
                  <select
                    value={newCourse.category}
                    onChange={(e) => setNewCourse({ ...newCourse, category: e.target.value })}
                    className="w-full bg-seryi-bg-dark border border-white/10 rounded-xl px-3 py-2.5 text-sm text-white"
                  >
                    <option value="onboarding">Onboarding</option>
                    <option value="ventas">Ventas & IA</option>
                    <option value="gestion">Gestión & Finanzas</option>
                    <option value="vip">Exclusivo VIP</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-bold text-seryi-text mb-1">Plan Requerido</label>
                  <select
                    value={newCourse.requiredPlan}
                    onChange={(e) => setNewCourse({ ...newCourse, requiredPlan: e.target.value })}
                    className="w-full bg-seryi-bg-dark border border-white/10 rounded-xl px-3 py-2.5 text-sm text-white"
                  >
                    <option value="free">Gratuito / Básico</option>
                    <option value="pro">Plan PRO</option>
                    <option value="vip">Plan VIP Enterprise</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-seryi-text mb-1">URL del Video Embed (YouTube / Loom)</label>
                <input
                  type="url"
                  required
                  value={newCourse.videoUrl}
                  onChange={(e) => setNewCourse({ ...newCourse, videoUrl: e.target.value })}
                  placeholder="https://www.youtube.com/embed/..."
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white"
                />
              </div>

              <div>
                <label className="block text-xs font-bold text-seryi-text mb-1">Descripción Breve</label>
                <textarea
                  rows="3"
                  value={newCourse.description}
                  onChange={(e) => setNewCourse({ ...newCourse, description: e.target.value })}
                  placeholder="Qué aprenderá el usuario con este módulo..."
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white"
                />
              </div>

              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowAdminModal(false)}
                  className="px-5 py-2.5 rounded-xl bg-white/10 text-white text-sm font-bold"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-xl bg-seryi-green text-seryi-bg-dark text-sm font-black hover:brightness-110"
                >
                  Guardar y Publicar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
